import ReplayIcon from '@mui/icons-material/Replay'
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  IconButton,
  Snackbar,
  Tooltip,
} from '@mui/material'
import { useState } from 'react'
import { resendAlertNotifications } from '@/services/notificationService'

type Props = { accountId: number; alertId: number }

const ResendAlertButton = ({ accountId, alertId }: Props) => {
  const [confirmOpen, setConfirmOpen] = useState(false)
  const [busy, setBusy] = useState(false)
  const [sent, setSent] = useState<number | null>(null)
  const [error, setError] = useState(false)

  const resend = async () => {
    setBusy(true)
    setError(false)
    try {
      const res = await resendAlertNotifications(accountId, alertId)
      setSent(res.notificationsEnqueued)
      setConfirmOpen(false)
    } catch {
      setError(true)
    } finally {
      setBusy(false)
    }
  }

  return (
    <>
      <Tooltip title="שליחה חוזרת">
        <IconButton size="small" onClick={() => setConfirmOpen(true)}>
          <ReplayIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle sx={{ direction: 'rtl' }}>
          לשלוח מחדש את הודעות ההתראה?
        </DialogTitle>
        {error && <Alert severity="error">השליחה נכשלה — נסו שוב</Alert>}
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)}>ביטול</Button>
          <Button onClick={resend} disabled={busy}>
            שליחה חוזרת
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={sent !== null}
        autoHideDuration={5000}
        onClose={() => setSent(null)}
        message={sent !== null ? `${sent} הודעות נשלחו מחדש` : ''}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        ContentProps={{ dir: 'rtl' }}
      />
    </>
  )
}

export default ResendAlertButton
